import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faDollarSign,
  faClock,
  faCheck,
  faTimes,
  faStar,
  faRocket,
  faCrown,
  faInfinity,
  faSquare,
  faCode,
  faPaintBrush,
  faBuilding,
  faPalette,
  faUserAstronaut,
  faCube,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";

const tabs = [
  { id: 'vectorization', label: 'Vectorization', icon: faSquare },
  { id: 'website-development', label: 'Website Development', icon: faCode },
  { id: 'logo-design', label: 'Logo Design', icon: faPaintBrush },
  { id: 'printing', label: 'Printing', icon: faPrint },
];

const packagesData = {
  vectorization: {
    packages: [
      {
        name: 'Starter',
        icon: faStar,
        tagline: 'Perfect for small businesses',
        price: 99,
        features: [
          { text: 'Up to 20 vector conversions/month', available: true },
          { text: '24-48 hour turnaround', available: true },
          { text: '2 free revisions per file', available: true },
          { text: 'Email support', available: true },
          { text: 'AI, EPS, SVG formats', available: true },
          { text: 'Priority support', available: false },
          { text: 'Dedicated account manager', available: false },
        ],
      },
      {
        name: 'Professional',
        icon: faRocket,
        tagline: 'Best for growing companies',
        price: 249,
        popular: true,
        features: [
          { text: 'Up to 75 vector conversions/month', available: true },
          { text: '12-24 hour turnaround', available: true },
          { text: 'Unlimited free revisions', available: true },
          { text: 'Priority email & phone support', available: true },
          { text: 'All formats included', available: true },
          { text: 'Priority queue placement', available: true },
          { text: 'Monthly performance reports', available: true },
        ],
      },
      {
        name: 'Enterprise',
        icon: faInfinity,
        tagline: 'Unlimited for large operations',
        price: 499,
        features: [
          { text: 'Unlimited vector conversions', available: true },
          { text: '6-12 hour turnaround', available: true },
          { text: 'Unlimited free revisions', available: true },
          { text: '24/7 dedicated support', available: true },
          { text: 'All formats + premium export', available: true },
          { text: 'Dedicated account manager', available: true },
          { text: 'Custom SLA agreements', available: true },
        ],
      },
    ],
  },
  'website-development': {
    packages: [
      {
        name: 'Basic Web',
        icon: faStar,
        tagline: 'Package',
        price: 199,
        originalPrice: 450,
        features: [
          { text: '1 Page Website Design', available: true },
          { text: 'HTML Based', available: true },
          { text: '1 Banner Design', available: true },
          { text: 'Contact/Query Form', available: true },
          { text: '3 Revisions', available: true },
          { text: 'Complete W3C Certified HTML', available: true },
          { text: 'Complete Deployment', available: true },
          { text: 'Complete Source Files', available: true },
          { text: 'Dedicated Project Manager', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Money Back Guarantee', available: true },
          { text: '*NO MONTHLY OR ANY HIDDEN FEE*', available: true },
        ],
      },
      {
        name: 'Start Web',
        icon: faRocket,
        tagline: 'Package',
        price: 425,
        originalPrice: 850,
        features: [
          { text: '3 Page Website Design', available: true },
          { text: 'HTML Based', available: true },
          { text: 'Hover Effects', available: true },
          { text: '2 Banner Designs', available: true },
          { text: 'Sliding Banner', available: true },
          { text: '2 Stock Photos (You can provide us more)', available: true },
          { text: 'Contact/Query Form', available: true },
          { text: 'FREE 12 Months Domain Name', available: true },
          { text: '6 Revisions', available: true },
          { text: 'Complete W3C Certified HTML', available: true },
          { text: 'Complete Deployment', available: true },
          { text: 'Complete Source Files', available: true },
          { text: 'Dedicated Project Manager', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Money Back Guarantee', available: true },
          { text: '*NO MONTHLY OR ANY HIDDEN FEE*', available: true },
        ],
      },
      {
        name: 'Professional Web',
        icon: faCode,
        tagline: 'Package',
        price: 825,
        originalPrice: 1650,
        features: [
          { text: 'Up to 5 Pages Website Design', available: true },
          { text: '3 Stock Photos (You can provide us more)', available: true },
          { text: '3 Banner Designs', available: true },
          { text: 'Sliding Banner', available: true },
          { text: 'Hoover Effects', available: true },
          { text: 'Content Management System (WordPress)', available: true },
          { text: 'FREE 12 Months Domain Name', available: true },
          { text: 'Search Engine Submission', available: true },
          { text: 'Unlimited Revisions', available: true },
          { text: 'Complete W3C Certified HTML', available: true },
          { text: 'Industry specified Team of Expert Designers and Developers', available: true },
          { text: 'Complete Deployment', available: true },
          { text: 'Complete Source Files', available: true },
          { text: 'Dedicated Project Manager', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Money Back Guarantee', available: true },
          { text: '*NO MONTHLY OR ANY HIDDEN FEE*', available: true },
        ],
      },
      {
        name: 'Identity Web',
        icon: faBuilding,
        tagline: 'Package',
        price: 1425,
        originalPrice: 2850,
        features: [
          { text: 'Unique 5 Pages Website Design', available: true },
          { text: 'Custom, Interactive, Dynamic & High End Web Design', available: true },
          { text: 'Custom WordPress Development', available: true },
          { text: '5 Stock Images', available: true },
          { text: '5 Banner Designs', available: true },
          { text: 'Sliding Banners', available: true },
          { text: 'Unlimited Revisions', available: true },
          { text: 'Special Hoover Effects', available: true },
          { text: 'Content Management System (WordPress)', available: true },
          { text: 'Mobile Responsive', available: true },
          { text: 'Online Appointment/Booking/Scheduling/Online Ordering Integration (If Required)', available: true },
          { text: 'FREE 12 Months Domain Name', available: true },
          { text: 'Google Friendly Sitemap', available: true },
          { text: 'Search Engine Submission', available: true },
          { text: 'Complete W3C Certified HTML', available: true },
          { text: 'Industry specified Team of Expert Designers and Developers', available: true },
          { text: 'Complete Deployment', available: true },
          { text: 'Complete Source Files', available: true },
          { text: 'Dedicated Project Manager', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Money Back Guarantee', available: true },
          { text: '*NO MONTHLY OR ANY HIDDEN FEE*', available: true },
        ],
      },
      {
        name: 'Elite Web',
        icon: faCrown,
        tagline: 'Package',
        price: 1825,
        originalPrice: 3650,
        features: [
          { text: '10 Unique Pages Website Design', available: true },
          { text: 'Custom, Interactive, Dynamic & High End Design', available: true },
          { text: 'Customize WordPress (or) PHP Development', available: true },
          { text: 'Interactive Sliding Banners', available: true },
          { text: '10 Stock Images', available: true },
          { text: '10 Banner Designs', available: true },
          { text: 'Special Hoover Effects', available: true },
          { text: 'Unlimited Revisions', available: true },
          { text: 'Content Management System (WordPress or Custom)', available: true },
          { text: 'Mobile Responsive', available: true },
          { text: 'Online Appointment/Booking/Scheduling/Online Ordering Integration (Optional)', available: true },
          { text: 'Online Payment Integration (Optional)', available: true },
          { text: 'FREE 24 Months Domain Name', available: true },
          { text: 'Google Friendly Sitemap', available: true },
          { text: 'Search Engine Submission', available: true },
          { text: 'Complete W3C Certified HTML', available: true },
          { text: 'Industry specified Team of Award Winning Designers and Developers', available: true },
          { text: 'Complete Deployment', available: true },
          { text: 'Complete Source Files', available: true },
          { text: 'Dedicated Project Manager', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Money Back Guarantee', available: true },
          { text: '*NO MONTHLY OR ANY HIDDEN FEE*', available: true },
        ],
      },
      {
        name: 'Corporate Web',
        icon: faInfinity,
        tagline: 'Package',
        price: 3425,
        originalPrice: 6850,
        features: [
          { text: '15 to 20 Unique Pages Website Design', available: true },
          { text: 'Custom Made, Interactive, Dynamic & High End Design', available: true },
          { text: 'Customized WordPress & PHP Development', available: true },
          { text: 'Interactive Sliding Banners', available: true },
          { text: 'Up to 15 Custom Made Banner Designs', available: true },
          { text: '15 Stock Images', available: true },
          { text: 'Unlimited Revisions', available: true },
          { text: 'Special Hoover Effects', available: true },
          { text: 'Content Management System', available: true },
          { text: 'Online Appointment/Booking/Scheduling/Online Ordering Integration (Optional)', available: true },
          { text: 'Online Payment Integration (Optional)', available: true },
          { text: 'Multi Lingual (Optional)', available: true },
          { text: 'Custom Dynamic Forms (Optional)', available: true },
          { text: 'Signup Area (For Newsletters, Offers etc.)', available: true },
          { text: 'Search Bar', available: true },
          { text: 'Live Feeds of Social Networks integration (Optional)', available: true },
          { text: 'Mobile Responsive', available: true },
          { text: 'FREE 24 Months Domain Name', available: true },
          { text: 'Google Friendly Sitemap', available: true },
          { text: 'Search Engine Submission', available: true },
          { text: 'Complete W3C Certified HTML', available: true },
          { text: 'Industry specified Team of Award Winning Designers and Developers', available: true },
          { text: 'Complete Deployment', available: true },
          { text: 'Complete Source Files', available: true },
          { text: 'Dedicated Project Manager', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Money Back Guarantee', available: true },
          { text: '*NO MONTHLY OR ANY HIDDEN FEE*', available: true },
        ],
      },
    ],
  },
  'logo-design': {
    packages: [
      {
        name: 'Basic Logo',
        icon: faStar,
        tagline: 'Package',
        price: 70,
        originalPrice: 140,
        features: [
          { text: '2 Custom Logo Design Concepts', available: true },
          { text: 'By 1 Designer', available: true },
          { text: '2 Revisions', available: true },
          { text: '48 to 72 hours TAT', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Money Back Guarantee*', available: true },
        ],
      },
      {
        name: 'Professional Logo',
        icon: faRocket,
        tagline: 'Package',
        price: 125,
        originalPrice: 250,
        features: [
          { text: '4 Logo Design Concepts', available: true },
          { text: 'By 2 Industry Based Designers', available: true },
          { text: 'UNLIMITED Revisions', available: true },
          { text: 'FREE MS Electronic Letterhead', available: true },
          { text: 'FREE Custom Stationery Design (Letterhead, Business Card, Envelope)', available: true },
          { text: '48 to 72 hours TAT', available: true },
          { text: 'FREE File Formats (EPS, Ai, GIF, JPEG, PSD)', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Money Back Guarantee*', available: true },
        ],
      },
      {
        name: 'Corporate Logo',
        icon: faBuilding,
        tagline: 'Package',
        price: 249,
        originalPrice: 498,
        features: [
          { text: '10 Logo Design Concepts', available: true },
          { text: 'By 4 Award Winning Designers', available: true },
          { text: 'Free Icon Design', available: true },
          { text: 'FREE Custom Stationery Design (Letterhead, Business Card, Envelope, Invoice)', available: true },
          { text: 'Double Side Flyer (OR) Bi-Fold Brochure', available: true },
          { text: 'FREE MS Electronic Letterhead', available: true },
          { text: 'Email Signature Design', available: true },
          { text: 'UNLIMITED Revisions', available: true },
          { text: '48 to 72 hours TAT', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Money Back Guarantee*', available: true },
        ],
      },
      {
        name: 'Illustrative Logo',
        icon: faPalette,
        tagline: 'Package',
        price: 399,
        originalPrice: 698,
        features: [
          { text: '3 Custom Illustrative Design Concepts', available: true },
          { text: 'By 3 Award Winning Designers', available: true },
          { text: 'UNLIMITED Revisions', available: true },
          { text: '72 hours Turnaround Time', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Money Back Guarantee*', available: true },
        ],
      },
      {
        name: 'Character Logo',
        icon: faUserAstronaut,
        tagline: 'Package',
        price: 200,
        originalPrice: 400,
        features: [
          { text: '3 Custom Character Logo', available: true },
          { text: 'By 3 Award Winning Designers', available: true },
          { text: 'UNLIMITED Revisions', available: true },
          { text: '72 hours Turnaround Time', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Money Back Guarantee*', available: true },
        ],
      },
      {
        name: '3D Logo',
        icon: faCube,
        tagline: 'Package',
        price: 450,
        originalPrice: 900,
        features: [
          { text: '3 Unique 3D Logo Concepts', available: true },
          { text: 'Light Effects and VFX', available: true },
          { text: 'Fully Rendered', available: true },
          { text: 'Multiple 3D Angles', available: true },
          { text: 'By 3 Award Winning Designers', available: true },
          { text: '72-120 hours Turnaround Time', available: true },
          { text: 'UNLIMITED Revisions', available: true },
          { text: '100% Ownership Rights', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Money Back Guarantee*', available: true },
        ],
      },
    ],
  },
  printing: {
    packages: [
      {
        name: 'Print Basic',
        icon: faStar,
        tagline: 'Package',
        price: 50,
        originalPrice: 100,
        features: [
          { text: '1 Business Card', available: true },
          { text: '1 Letterhead', available: true },
          { text: '1 Envelope', available: true },
          { text: '5 Revisions', available: true },
          { text: '2-3 Business Days Turnaround Time', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Money Back Guarantee*', available: true },
        ],
      },
      {
        name: 'Print Startup',
        icon: faRocket,
        tagline: 'Package',
        price: 70,
        originalPrice: 140,
        features: [
          { text: '2 Business Card', available: true },
          { text: '2 Letterhead', available: true },
          { text: '2 Envelope', available: true },
          { text: 'FREE MS Electronic Letterhead', available: true },
          { text: 'UNLIMITED Revisions', available: true },
          { text: '2-3 Business Days Turnaround Time', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Money Back Guarantee*', available: true },
        ],
      },
      {
        name: 'Print Sinage',
        icon: faBuilding,
        tagline: 'Package',
        price: 150,
        originalPrice: 300,
        features: [
          { text: '1 Sinage Design', available: true },
          { text: 'Print Ready Formats', available: true },
          { text: 'UNLIMITED Revisions', available: true },
          { text: '100% Money Back Guarantee*', available: true },
          { text: '100% Unique Design Guarantee', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
        ],
      },
      {
        name: 'Collateral Basic',
        icon: faPalette,
        tagline: 'Package',
        price: 100,
        originalPrice: 200,
        features: [
          { text: '100% Satisfaction Guarantee', available: true },
          { text: 'Money Back Guarantee', available: true },
          { text: '2 Stationary design concepts', available: true },
          { text: 'Free fax template', available: true },
          { text: 'Print ready formats', available: true },
          { text: 'Unlimited Revision', available: true },
        ],
      },
      {
        name: 'Collateral Professional',
        icon: faCrown,
        tagline: 'Package',
        price: 250,
        originalPrice: 500,
        features: [
          { text: 'Money Back Guarantee', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: 'Unlimited Revision', available: true },
          { text: '2 Stationary design concepts', available: true },
          { text: 'T-shirt Design', available: true },
          { text: 'Packaging Design', available: true },
        ],
      },
      {
        name: 'Collateral Corporate',
        icon: faInfinity,
        tagline: 'Package',
        price: 525,
        originalPrice: 1050,
        features: [
          { text: 'Unlimited Revision', available: true },
          { text: '100% Satisfaction Guarantee', available: true },
          { text: 'Money Back Guarantee', available: true },
          { text: 'T-shirt Design', available: true },
          { text: 'Menu Card Design', available: true },
          { text: 'Banner Design', available: true },
        ],
      },
    ],
  },
};

export default function Pricing() {
  const [activeTab, setActiveTab] = useState('vectorization');
  const [embroideryTab, setEmbroideryTab] = useState('stitch-base');
  const { packages } = packagesData[activeTab];
  const isProjectPackage = activeTab === 'logo-design' || activeTab === 'website-development' || activeTab === 'printing';

  return (
    <>
      <Header />

      <section className="breadcrumbsection">
        <div className='container'>
          <h1>Pricing</h1>
          <ul className='breadcrumblinks'>
            <li><Link to="/">Home</Link></li>
            <li><FontAwesomeIcon icon={faChevronRight} /></li>
            <li>Pricing</li>
          </ul>
        </div>
      </section>

      {/* Embroidery Digitizing Pricing Section */}
      <section className="pricing-main-section embroidery-pricing-section">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="section-title">Embroidery Digitizing Pricing</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">Simple, transparent pricing for professional embroidery digitizing services</p>
          </div>

          {/* Embroidery Tabs */}
          <div className="emb-tabs-wrapper mb-4">
            <ul className="emb-tabs">
              <li>
                <button
                  className={`emb-tab-btn ${embroideryTab === 'stitch-base' ? 'active' : ''}`}
                  onClick={() => setEmbroideryTab('stitch-base')}
                >
                  <FontAwesomeIcon icon={faDollarSign} />
                  Stitch Base
                </button>
              </li>
              <li>
                <button
                  className={`emb-tab-btn ${embroideryTab === 'flat-rates' ? 'active' : ''}`}
                  onClick={() => setEmbroideryTab('flat-rates')}
                >
                  <FontAwesomeIcon icon={faClock} />
                  Flat Rates
                </button>
              </li>
            </ul>
          </div>

          {/* Stitch Base Tab */}
          {embroideryTab === 'stitch-base' && (
            <div className="pricing-cards-wrapper">
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="pricing-info-card">
                    <div className="pricing-card-icon">
                      <FontAwesomeIcon icon={faDollarSign} />
                    </div>
                    <h3 className="pricing-card-title">Stitch Base Pricing</h3>
                    <div className="pricing-details-list">
                      <div className="pricing-detail-item">
                        <span className="detail-label">Per 1000 Stitches:</span>
                        <span className="detail-value highlight">$1.00</span>
                      </div>
                      <div className="pricing-detail-item">
                        <span className="detail-label">Minimum Design Fee:</span>
                        <span className="detail-value">$7.00</span>
                        <span className="detail-info">(Up to 7000 stitches)</span>
                      </div>
                      <div className="pricing-detail-item">
                        <span className="detail-label">Maximum Design Fee:</span>
                        <span className="detail-value">$80.00</span>
                        <span className="detail-info">(70000 stitches)</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="pricing-info-card">
                    <div className="pricing-card-icon">
                      <FontAwesomeIcon icon={faClock} />
                    </div>
                    <h3 className="pricing-card-title">Turnaround Time</h3>
                    <div className="turnaround-options">
                      <div className="turnaround-option standard">
                        <div className="option-badge">Normal Logos</div>
                        <div className="option-time">5-8 Hours</div>
                        <div className="option-detail">Guaranteed</div>
                      </div>
                      <div className="turnaround-option priority">
                        <div className="option-badge">Complex Designs</div>
                        <div className="option-time">12-24 Hours</div>
                        <div className="option-price">+$3.00</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Flat Rates Tab */}
          {embroideryTab === 'flat-rates' && (
            <div className="flat-rates-wrapper">
              <div className="row g-4 justify-content-center">

                <div className="col-lg-4 col-md-6">
                  <div className="flat-rate-card">
                    <h3 className="flat-rate-title">Left Chest / Caps</h3>
                    <div className="flat-rate-spec">
                      <FontAwesomeIcon icon={faCheck} className="flat-rate-check" />
                      <span>Within 4.5 x 4.5 Inch</span>
                    </div>
                    <div className="flat-rate-price">$20.00</div>
                    <div className="flat-rate-divider"></div>
                    <div className="flat-rate-limits-label">Pricing Limits</div>
                    <div className="flat-rate-limit-item">
                      <FontAwesomeIcon icon={faCheck} className="flat-rate-check" />
                      <span>No Limits. Unlimited Stitches For All Sizes</span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="flat-rate-card">
                    <h3 className="flat-rate-title">Portrait / Center Chest</h3>
                    <div className="flat-rate-spec">
                      <FontAwesomeIcon icon={faCheck} className="flat-rate-check" />
                      <span>Max 8 x 8 Inch</span>
                    </div>
                    <div className="flat-rate-price">$35</div>
                    <div className="flat-rate-divider"></div>
                    <div className="flat-rate-limits-label">Pricing Limits</div>
                    <div className="flat-rate-limit-item">
                      <FontAwesomeIcon icon={faCheck} className="flat-rate-check" />
                      <span>No Limits. Unlimited Stitches For All Sizes</span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="flat-rate-card">
                    <h3 className="flat-rate-title">Full Fronts / Jacket Back</h3>
                    <div className="flat-rate-spec">
                      <FontAwesomeIcon icon={faCheck} className="flat-rate-check" />
                      <span>Over 8+ x 8+ Inch</span>
                    </div>
                    <div className="flat-rate-price">$55</div>
                    <div className="flat-rate-divider"></div>
                    <div className="flat-rate-limits-label">Pricing Limits</div>
                    <div className="flat-rate-limit-item">
                      <FontAwesomeIcon icon={faCheck} className="flat-rate-check" />
                      <span>No Limits. Unlimited Stitches For All Sizes</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          )}

        </div>
      </section>

      {/* Other Services Pricing Section */}
      <section className="subscription-main-section packages-section">
        <div className="container">
          <div className="subscription-section-header text-center mb-5">
            <h2 className="subscription-section-title">Other Services Pricing</h2>
            <div className="subscription-title-underline"></div>
            <p className="subscription-section-subtitle">
              Flexible monthly subscription plans designed to meet your business needs
            </p>
          </div>

          {/* Service Tabs */}
          <div className="subscription-tabs-wrapper mb-5">
            <ul className="subscription-tabs">
              {tabs.map((tab) => (
                <li key={tab.id}>
                  <button
                    className={`subscription-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <FontAwesomeIcon icon={tab.icon} className="tab-icon" />
                    <span>{tab.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Packages */}
          <div className="subscription-packages-wrapper">
            <div className="row g-4 justify-content-center">
              {packages.map((pkg) => (
                <div className="col-lg-4 col-md-6" key={pkg.name}>
                  <div className="subscription-package-card professional-package">
                    {pkg.popular && (
                      <div className="popular-badge">
                        <FontAwesomeIcon icon={faCrown} />
                        <span>Most Popular</span>
                      </div>
                    )}

                    <div className="package-header">
                      <div className="package-icon">
                        <FontAwesomeIcon icon={pkg.icon} />
                      </div>
                      <h3 className="package-name">{pkg.name}</h3>
                      <p className="package-tagline">{pkg.tagline}</p>
                    </div>

                    <div className="package-pricing">
                      {isProjectPackage ? (
                        <>
                          <div className="price-display">
                            <span className="currency">$</span>
                            <span className="amount">{pkg.price.toFixed(2)}</span>
                          </div>
                          <p className="billing-info">
                            <span className="package-discount">50% OFF !</span>
                            <span className="original-price">${pkg.originalPrice.toFixed(2)}</span>
                          </p>
                        </>
                      ) : (
                        <>
                          <div className="price-display">
                            <span className="currency">$</span>
                            <span className="amount">{pkg.price}</span>
                            <span className="period">/month</span>
                          </div>
                          <p className="billing-info">Billed monthly</p>
                        </>
                      )}
                    </div>

                    <div className="package-features">
                      <ul className="features-list">
                        {pkg.features.map((feature, index) => (
                          <li key={index} className={`feature-item ${feature.available ? 'available' : 'unavailable'}`}>
                            <FontAwesomeIcon
                              icon={feature.available ? faCheck : faTimes}
                              className="feature-icon"
                            />
                            <span>{feature.text}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="package-cta">
                      <button className="subscription-btn btn-professional">
                        {isProjectPackage ? 'Start Project' : 'Get Started'}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      <Newsletter />
      <Footer />
    </>
  );
}